<template>
  <div class="news-detail">
    <div class="container">
      <!-- 面包屑导航 -->
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
          <el-breadcrumb-item><a href="/news">新闻中心</a></el-breadcrumb-item>
          <el-breadcrumb-item>{{ news.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 新闻详情 -->
      <div class="news-content">
        <h1 class="news-title">{{ news.title }}</h1>
        <div class="news-meta">
          <span class="publish-time">{{ formatDate(news.createdAt) }}</span>
        </div>
        
        <!-- 新闻内容 -->
        <div class="news-body" v-html="news.content" @click="handleContentClick"></div>
        
        <!-- 分页导航 -->
        <div class="news-nav">
          <div class="prev-news" v-if="prevNews">
            <span>上一篇：</span>
            <a :href="`/news/${prevNews.id}`">{{ prevNews.title }}</a>
          </div>
          <div class="next-news" v-if="nextNews">
            <span>下一篇：</span>
            <a :href="`/news/${nextNews.id}`">{{ nextNews.title }}</a>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 图片预览 -->
    <div class="image-preview" v-if="previewVisible" @click="closePreview">
      <div class="preview-overlay"></div>
      <div class="preview-container">
        <img :src="previewImageUrl" alt="预览图片" />
        <button class="preview-close" @click.stop="closePreview">&times;</button>
      </div>
    </div>
  </div>
</template>

<script>
import { newsApi } from '@/api'

export default {
  name: 'NewsDetail',
  data() {
    return {
      news: {
        id: '',
        title: '',
        content: '',
        createdAt: ''
      },
      prevNews: null,
      nextNews: null,
      previewVisible: false,
      previewImageUrl: ''
    }
  },
  mounted() {
    this.getNewsDetail()
    this.getAdjacentNews()
  },
  methods: {
    getNewsDetail() {
      const newsId = this.$route.params.id
      newsApi.getNewsById(newsId).then(res => {
        if (res) {
          this.news = res.data || {}
        }
      }).catch(() => {
        // 静默处理错误
      })
    },
    getAdjacentNews() {
      // 这里需要实现获取上一篇和下一篇新闻的API
      // 暂时使用模拟数据
      this.prevNews = null
      this.nextNews = null
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    handleContentClick(event) {
      // 处理内容区域点击事件，检查是否点击图片
      if (event.target.tagName === 'IMG') {
        this.showPreview(event.target.src)
      }
    },
    showPreview(imageUrl) {
      // 显示图片预览
      this.previewImageUrl = imageUrl
      this.previewVisible = true
    },
    closePreview() {
      // 关闭图片预览
      this.previewVisible = false
      this.previewImageUrl = ''
    }
  }
}
</script>

<style scoped>
.news-detail {
  padding: 40px 0;
  background-color: #f5f7fa;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.breadcrumb {
  margin-bottom: 30px;
  padding: 10px 0;
  border-bottom: 1px solid #e0e0e0;
}

.news-content {
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.news-title {
  font-size: 2rem;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
  line-height: 1.3;
}

.news-meta {
  text-align: center;
  color: #999;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.publish-time {
  font-size: 0.9rem;
}

.news-body {
  font-size: 1rem;
  line-height: 1.8;
  color: #333;
  margin-bottom: 40px;
}

/* 内容样式 */
.news-body p {
  margin-bottom: 16px;
  text-indent: 2em;
}

.news-body h2 {
  font-size: 1.5rem;
  margin: 30px 0 20px;
  color: #333;
}

.news-body h3 {
  font-size: 1.2rem;
  margin: 25px 0 15px;
  color: #333;
}

.news-body img {
  max-width: 100%;
  height: auto;
  margin: 20px 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.news-body table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.news-body th,
.news-body td {
  padding: 12px;
  text-align: left;
  border: 1px solid #e0e0e0;
}

.news-body th {
  background-color: #f5f5f5;
  font-weight: bold;
  color: #333;
}

.news-body tr:hover {
  background-color: #f9f9f9;
}

/* 文章内容中的图片点击效果 */
.news-body img {
  cursor: zoom-in;
  transition: opacity 0.3s ease;
}

.news-body img:hover {
  opacity: 0.9;
}

/* 图片预览 */
.image-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
}

.preview-container {
  position: relative;
  z-index: 1;
  max-width: 90%;
  max-height: 90%;
}

.preview-container img {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 4px;
}

.preview-close {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: #fff;
  font-size: 36px;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;
}

.preview-close:hover {
  color: #ff6b6b;
}


/* 分页导航 */
.news-nav {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.prev-news,
.next-news {
  flex: 1;
  min-width: 200px;
}

.prev-news a,
.next-news a {
  color: #165DFF;
  text-decoration: none;
  transition: color 0.3s ease;
}

.prev-news a:hover,
.next-news a:hover {
  color: #0e47c2;
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .news-content {
    padding: 20px;
  }
  
  .news-title {
    font-size: 1.5rem;
  }
  
  .image-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
  
  .image-item img {
    height: 120px;
  }
  
  .news-nav {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .prev-news,
  .next-news {
    width: 100%;
  }
}
</style>
